import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-renew-password-link-sent',
    templateUrl: './renew-password-link-sent.component.html',
    styleUrls: ['./renew-password-link-sent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RenewPasswordLinkSentComponent implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
